export function ArticleOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
        fill="#424242"
      />
      <path d="M14 17H7v-2h7zm3-4H7v-2h10zm0-4H7V7h10z" fill="#424242" />
    </svg>
  );
}

export function AssessmentOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function BusinessOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function CableOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 5V4C20 3.45 19.55 3 19 3H17C16.45 3 16 3.45 16 4V5H15V9C15 9.55 15.45 10 16 10H17V17C17 18.1 16.1 19 15 19C13.9 19 13 18.1 13 17V7C13 4.79 11.21 3 9 3C6.79 3 5 4.79 5 7V14H4C3.45 14 3 14.45 3 15V19H4V20C4 20.55 4.45 21 5 21H7C7.55 21 8 20.55 8 20V19H9V15C9 14.45 8.55 14 8 14H7V7C7 5.9 7.9 5 9 5C10.1 5 11 5.9 11 7V17C11 19.21 12.79 21 15 21C17.21 21 19 19.21 19 17V10H20C20.55 10 21 9.55 21 9V5H20Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function CalculateOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
        fill="#9E9E9E"
      ></path>
      <path d="M11.25 7.72H6.25V9.22H11.25V7.72Z" fill="#9E9E9E"></path>
      <path d="M18 15.75H13V17.25H18V15.75Z" fill="#9E9E9E"></path>
      <path d="M18 13.25H13V14.75H18V13.25Z" fill="#9E9E9E"></path>
      <path d="M8 18H9.5V16H11.5V14.5H9.5V12.5H8V14.5H6V16H8V18Z" fill="#9E9E9E"></path>
      <path
        d="M14.09 10.95L15.5 9.54L16.91 10.95L17.97 9.89L16.56 8.47L17.97 7.06L16.91 6L15.5 7.41L14.09 6L13.03 7.06L14.44 8.47L13.03 9.89L14.09 10.95Z"
        fill="#9E9E9E"
      ></path>
    </svg>
  );
}

export function CampaignOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 11C18 11.67 18 12.33 18 13C19.2 13 20.76 13 22 13C22 12.33 22 11.67 22 11C20.76 11 19.2 11 18 11Z"
        fill="#424242"
      ></path>
      <path
        d="M16 17.61C16.96 18.32 18.21 19.26 19.2 20C19.6 19.47 20 18.93 20.4 18.4C19.41 17.66 18.16 16.72 17.2 16C16.8 16.54 16.4 17.08 16 17.61Z"
        fill="#424242"
      ></path>
      <path
        d="M20.4 5.6C20 5.07 19.6 4.53 19.2 4C18.21 4.74 16.96 5.68 16 6.4C16.4 6.93 16.8 7.47 17.2 8C18.16 7.28 19.41 6.35 20.4 5.6Z"
        fill="#424242"
      ></path>
      <path
        d="M4 9C2.9 9 2 9.9 2 11V13C2 14.1 2.9 15 4 15H5V19H7V15H8L13 18V6L8 9H4ZM9.03 10.71L11 9.53V14.47L9.03 13.29L8.55 13H4V11H8.55L9.03 10.71Z"
        fill="#424242"
      ></path>
      <path
        d="M15.5 12C15.5 10.67 14.92 9.46999 14 8.64999V15.34C14.92 14.53 15.5 13.33 15.5 12Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function ChecklistOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 6.99993H13V8.99993H22V6.99993ZM22 14.9999H13V16.9999H22V14.9999ZM5.54 10.9999L2 7.45993L3.41 6.04993L5.53 8.16993L9.77 3.92993L11.18 5.33993L5.54 10.9999ZM5.54 18.9999L2 15.4599L3.41 14.0499L5.53 16.1699L9.77 11.9299L11.18 13.3399L5.54 18.9999Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function DescriptionOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 16H16V18H8V16ZM8 12H16V14H8V12ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function EditNoteOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 10H14V12H3V10ZM3 8H14V6H3V8ZM3 16H10V14H3V16ZM18.01 12.87L18.72 12.16C19.11 11.77 19.74 11.77 20.13 12.16L20.84 12.87C21.23 13.26 21.23 13.89 20.84 14.28L20.13 14.99L18.01 12.87ZM17.3 13.58L12 18.88V21H14.12L19.42 15.7L17.3 13.58Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function EqualizerOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 20H14V4H10V20ZM4 20H8V12H4V20ZM16 9V20H20V9H16Z" fill="#424242"></path>
    </svg>
  );
}

export function FolderOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.17 6L11.17 8H20V18H4V6H9.17ZM10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function GppGoodOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.31L12 4.19L18 6.31V11.09ZM8.82 10.59L7.4 12L10.94 15.54L16.6 9.88L15.19 8.47L10.95 12.71L8.82 10.59Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function GridOnOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM8 20H4V16H8V20ZM8 14H4V10H8V14ZM8 8H4V4H8V8ZM14 20H10V16H14V20ZM14 14H10V10H14V14ZM14 8H10V4H14V8ZM20 20H16V16H20V20ZM20 14H16V10H20V14ZM20 8H16V4H20V8Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function InsightsOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 8C19.55 8 18.74 9.44 19.07 10.51L15.52 14.07C15.22 13.98 14.78 13.98 14.48 14.07L11.93 11.52C12.27 10.45 11.46 9 10 9C8.55 9 7.73 10.44 8.07 11.52L3.51 16.07C2.44 15.74 1 16.55 1 18C1 19.1 1.9 20 3 20C4.45 20 5.26 18.56 4.93 17.49L9.48 12.93C9.78 13.02 10.22 13.02 10.52 12.93L13.07 15.48C12.73 16.55 13.54 18 15 18C16.45 18 17.27 16.56 16.93 15.48L20.49 11.93C21.56 12.26 23 11.45 23 10C23 8.9 22.1 8 21 8Z"
        fill="#424242"
      ></path>
      <path d="M15 9L15.94 6.93L18 6L15.94 5.07L15 3L14.08 5.07L12 6L14.08 6.93L15 9Z" fill="#424242"></path>
      <path d="M3.5 11L4 9L6 8.5L4 8L3.5 6L3 8L1 8.5L3 9L3.5 11Z" fill="#424242"></path>
    </svg>
  );
}

export function IntegrationInstructionsOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 14.17L8.83 12L11 9.83L9.59 8.41L6 12L9.59 15.59L11 14.17Z" fill="#424242"></path>
      <path d="M14.41 15.59L18 12L14.41 8.41L13 9.83L15.17 12L13 14.17L14.41 15.59Z" fill="#424242"></path>
      <path
        d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.46 3 4.72 3 5V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM19 19H5V5H19V19Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function LeftNavItems() {
  return (
    <svg width="311" height="40" viewBox="0 0 311 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.5 18H20.5V25H22.5V18ZM28.5 18H26.5V25H28.5V18ZM37 27H18V29H37V27ZM34.5 18H32.5V25H34.5V18ZM27.5 11.26L32.71 14H22.29L27.5 11.26ZM27.5 9L18 14V16H37V14L27.5 9Z"
        fill="#424242"
      ></path>
      <path
        d="M53.255 15.3182V25.5H51.1023V17.3615H51.0426L48.7109 18.8232V16.9141L51.2315 15.3182H53.255ZM59.6671 25.7237C58.812 25.7204 58.0762 25.5099 57.4597 25.0923C56.8465 24.6747 56.3742 24.0698 56.0428 23.2777C55.7147 22.4856 55.5523 21.5327 55.5556 20.419C55.5556 19.3087 55.7196 18.3625 56.0478 17.5803C56.3792 16.7981 56.8515 16.2031 57.4647 15.7955C58.0811 15.3845 58.8153 15.179 59.6671 15.179C60.5189 15.179 61.2514 15.3845 61.8645 15.7955C62.481 16.2064 62.955 16.803 63.2864 17.5852C63.6178 18.3641 63.7819 19.3087 63.7786 20.419C63.7786 21.536 63.6129 22.4905 63.2814 23.2827C62.9533 24.0748 62.4827 24.6797 61.8695 25.0973C61.2563 25.5149 60.5222 25.7237 59.6671 25.7237ZM59.6671 23.9389C60.2504 23.9389 60.7161 23.6456 61.0641 23.0589C61.4121 22.4723 61.5845 21.5923 61.5811 20.419C61.5811 19.6468 61.5016 19.0038 61.3425 18.4901C61.1867 17.9763 60.9647 17.5902 60.6763 17.3317C60.3913 17.0732 60.0549 16.9439 59.6671 16.9439C59.0871 16.9439 58.623 17.2339 58.275 17.8139C57.927 18.3939 57.7514 19.2623 57.748 20.419C57.748 21.2012 57.8259 21.8542 57.9817 22.3778C58.1408 22.8982 58.3645 23.2893 58.6529 23.5511C58.9412 23.8097 59.2793 23.9389 59.6671 23.9389ZM68.9975 15.179C69.5212 15.179 70.025 15.2668 70.5089 15.4425C70.9961 15.6181 71.4303 15.8982 71.8114 16.2827C72.1959 16.6671 72.4992 17.1776 72.7212 17.8139C72.9466 18.447 73.061 19.2242 73.0643 20.1456C73.0643 21.0107 72.9665 21.7829 72.771 22.4624C72.5787 23.1385 72.302 23.7135 71.9407 24.1875C71.5794 24.6615 71.1436 25.0227 70.6332 25.2713C70.1228 25.5166 69.5527 25.6392 68.9229 25.6392C68.2435 25.6392 67.6436 25.5083 67.1232 25.2464C66.6029 24.9813 66.1836 24.6217 65.8654 24.1676C65.5505 23.7102 65.36 23.1965 65.2937 22.6264H67.4165C67.4994 22.9976 67.6734 23.286 67.9386 23.4915C68.2037 23.6937 68.5318 23.7947 68.9229 23.7947C69.5858 23.7947 70.0896 23.5064 70.4343 22.9297C70.779 22.3497 70.953 21.5559 70.9563 20.5483H70.8867C70.7343 20.8466 70.5288 21.1035 70.2702 21.3189C70.0117 21.531 69.7151 21.6951 69.3803 21.8111C69.0489 21.9271 68.6959 21.9851 68.3214 21.9851C67.7215 21.9851 67.1862 21.8442 66.7156 21.5625C66.2449 21.2808 65.8737 20.893 65.6019 20.3991C65.3301 19.9053 65.1942 19.3419 65.1942 18.7088C65.1909 18.026 65.3484 17.4179 65.6665 16.8842C65.9847 16.3506 66.4289 15.933 66.9989 15.6314C67.5723 15.3265 68.2385 15.1757 68.9975 15.179ZM69.0124 16.8693C68.6777 16.8693 68.3794 16.9489 68.1175 17.108C67.859 17.267 67.6535 17.4808 67.5011 17.7493C67.3519 18.0178 67.279 18.3177 67.2823 18.6491C67.2823 18.9839 67.3552 19.2855 67.5011 19.554C67.6502 19.8191 67.8524 20.0312 68.1076 20.1903C68.3661 20.3461 68.6611 20.424 68.9925 20.424C69.2411 20.424 69.4715 20.3776 69.6836 20.2848C69.8957 20.192 70.0797 20.0644 70.2354 19.902C70.3945 19.7363 70.5188 19.5457 70.6083 19.3303C70.6978 19.1148 70.7425 18.8861 70.7425 18.6442C70.7392 18.3227 70.663 18.0277 70.5138 17.7592C70.3647 17.4908 70.1592 17.2753 69.8974 17.1129C69.6355 16.9505 69.3406 16.8693 69.0124 16.8693ZM78.2397 15.179C78.7634 15.179 79.2672 15.2668 79.7511 15.4425C80.2383 15.6181 80.6725 15.8982 81.0536 16.2827C81.4381 16.6671 81.7414 17.1776 81.9634 17.8139C82.1888 18.447 82.3031 19.2242 82.3065 20.1456C82.3065 21.0107 82.2087 21.7829 82.0131 22.4624C81.8209 23.1385 81.5442 23.7135 81.1829 24.1875C80.8216 24.6615 80.3858 25.0227 79.8754 25.2713C79.3649 25.5166 78.7949 25.6392 78.1651 25.6392C77.4857 25.6392 76.8858 25.5083 76.3654 25.2464C75.8451 24.9813 75.4258 24.6217 75.1076 24.1676C74.7927 23.7102 74.6022 23.1965 74.5359 22.6264H76.6587C76.7416 22.9976 76.9156 23.286 77.1808 23.4915C77.4459 23.6937 77.774 23.7947 78.1651 23.7947C78.828 23.7947 79.3318 23.5064 79.6765 22.9297C80.0212 22.3497 80.1952 21.5559 80.1985 20.5483H80.1289C79.9764 20.8466 79.771 21.1035 79.5124 21.3189C79.2539 21.531 78.9573 21.6951 78.6225 21.8111C78.2911 21.9271 77.9381 21.9851 77.5636 21.9851C76.9637 21.9851 76.4284 21.8442 75.9577 21.5625C75.4871 21.2808 75.1159 20.893 74.8441 20.3991C74.5723 19.9053 74.4364 19.3419 74.4364 18.7088C74.4331 18.026 74.5906 17.4179 74.9087 16.8842C75.2269 16.3506 75.671 15.933 76.2411 15.6314C76.8145 15.3265 77.4807 15.1757 78.2397 15.179ZM78.2546 16.8693C77.9199 16.8693 77.6216 16.9489 77.3597 17.108C77.1012 17.267 76.8957 17.4808 76.7433 17.7493C76.5941 18.0178 76.5212 18.3177 76.5245 18.6491C76.5245 18.9839 76.5974 19.2855 76.7433 19.554C76.8924 19.8191 77.0946 20.0312 77.3498 20.1903C77.6083 20.3461 77.9033 20.424 78.2347 20.424C78.4833 20.424 78.7137 20.3776 78.9258 20.2848C79.1379 20.192 79.3219 20.0644 79.4776 19.902C79.6367 19.7363 79.761 19.5457 79.8505 19.3303C79.94 19.1148 79.9847 18.8861 79.9847 18.6442C79.9814 18.3227 79.9052 18.0277 79.756 17.7592C79.6069 17.4908 79.4014 17.2753 79.1396 17.1129C78.8777 16.9505 78.5827 16.8693 78.2546 16.8693Z"
        fill="#424242"
      ></path>
      <path
        d="M291.59 16.59L287 21.17L282.41 16.59L281 18L287 24L293 18L291.59 16.59Z"
        fill="black"
        fillOpacity="0.54"
      ></path>
    </svg>
  );
}

export function ListAltOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 7H17V9H11V7ZM11 11H17V13H11V11ZM11 15H17V17H11V15ZM7 7H9V9H7V7ZM7 11H9V13H7V11ZM7 15H9V17H7V15ZM20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3ZM19 19H5V5H19V19Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function ListOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function LocationCityOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 11V5L12 2L9 5V7H3V21H21V11H15ZM7 19H5V17H7V19ZM7 15H5V13H7V15ZM7 11H5V9H7V11ZM13 19H11V17H13V19ZM13 15H11V13H13V15ZM13 11H11V9H13V11ZM13 7H11V5H13V7ZM19 19H17V17H19V19ZM19 15H17V13H19V15Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function ManageAccountsOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 18V17.35C4 17.01 4.16 16.69 4.41 16.54C6.1 15.53 8.03 15 10 15C10.03 15 10.05 15 10.08 15.01C10.18 14.31 10.38 13.64 10.67 13.03C10.45 13.01 10.23 13 10 13C7.58 13 5.32 13.67 3.39 14.82C2.51 15.34 2 16.32 2 17.35V20H11.26C10.84 19.4 10.51 18.72 10.29 18H4Z"
        fill="#424242"
      ></path>
      <path
        d="M10 12C12.21 12 14 10.21 14 8C14 5.79 12.21 4 10 4C7.79 4 6 5.79 6 8C6 10.21 7.79 12 10 12ZM10 6C11.1 6 12 6.9 12 8C12 9.1 11.1 10 10 10C8.9 10 8 9.1 8 8C8 6.9 8.9 6 10 6Z"
        fill="#424242"
      ></path>
      <path
        d="M20.75 16C20.75 15.78 20.72 15.58 20.69 15.37L21.83 14.36L20.83 12.63L19.38 13.12C19.06 12.85 18.7 12.64 18.3 12.49L18 11H16L15.7 12.49C15.3 12.64 14.94 12.85 14.62 13.12L13.17 12.63L12.17 14.36L13.31 15.37C13.28 15.58 13.25 15.78 13.25 16C13.25 16.22 13.28 16.42 13.31 16.63L12.17 17.64L13.17 19.37L14.62 18.88C14.94 19.15 15.3 19.36 15.7 19.51L16 21H18L18.3 19.51C18.7 19.36 19.06 19.15 19.38 18.88L20.83 19.37L21.83 17.64L20.69 16.63C20.72 16.42 20.75 16.22 20.75 16ZM17 18C15.9 18 15 17.1 15 16C15 14.9 15.9 14 17 14C18.1 14 19 14.9 19 16C19 17.1 18.1 18 17 18Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function ManageSearchOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 9H2V7H7V9ZM7 12H2V14H7V12ZM20.59 19L16.76 15.17C15.96 15.69 15.02 16 14 16C11.24 16 9 13.76 9 11C9 8.24 11.24 6 14 6C16.76 6 19 8.24 19 11C19 12.02 18.69 12.96 18.17 13.75L22 17.59L20.59 19ZM17 11C17 9.35 15.65 8 14 8C12.35 8 11 9.35 11 11C11 12.65 12.35 14 14 14C15.65 14 17 12.65 17 11ZM2 19H12V17H2V19Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function OtherHousesOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 3L1 11.4L2.21 12.99L4 11.62V21H20V11.62L21.79 12.98L23 11.4L12 3ZM18 19H6V10.1L12 5.52L18 10.1V19ZM9 14C9 14.55 8.55 15 8 15C7.45 15 7 14.55 7 14C7 13.45 7.45 13 8 13C8.55 13 9 13.45 9 14ZM12 13C12.55 13 13 13.45 13 14C13 14.55 12.55 15 12 15C11.45 15 11 14.55 11 14C11 13.45 11.45 13 12 13ZM15 14C15 13.45 15.45 13 16 13C16.55 13 17 13.45 17 14C17 14.55 16.55 15 16 15C15.45 15 15 14.55 15 14Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function PaidOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.89 11.1C11.11 10.51 10.25 10.14 10.25 9.2C10.25 8.18 11.36 7.81 12.06 7.81C13.37 7.81 13.85 8.8 13.96 9.15L15.54 8.48C15.39 8.04 14.72 6.57 12.88 6.25V5H11.13V6.26C8.53 6.82 8.51 9.11 8.51 9.22C8.51 11.49 10.76 12.13 11.86 12.53C13.44 13.09 14.14 13.6 14.14 14.56C14.14 15.69 13.09 16.17 12.16 16.17C10.34 16.17 9.82 14.3 9.76 14.08L8.1 14.75C8.73 16.94 10.38 17.53 11.12 17.71V19H12.87V17.76C13.39 17.67 15.89 17.17 15.89 14.54C15.9 13.15 15.29 11.93 12.89 11.1Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function ReceiptOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5ZM19 19.09H5V4.91H19V19.09ZM6 15H18V17H6V15ZM6 11H18V13H6V11ZM6 7H18V9H6V7Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function RequestQuoteOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 20V4H13V8H18V20H6ZM11 19H13V18H14C14.55 18 15 17.55 15 17V14C15 13.45 14.55 13 14 13H11V12H15V10H13V9H11V10H10C9.45 10 9 10.45 9 11V14C9 14.55 9.45 15 10 15H13V16H9V18H11V19Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function SchemaOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 9V11H11V9H8.5V7H11V1H4V7H6.5V9H4V15H6.5V17H4V23H11V17H8.5V15H11V13H14V15H21V9H14ZM6 3H9V5H6V3ZM9 21H6V19H9V21ZM9 13H6V11H9V13ZM19 13H16V11H19V13Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function SecurityOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11.99H19C18.47 16.11 15.72 19.78 12 20.93V12H5V6.3L12 3.19V11.99Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function SourceOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM18 12H6V10H18V12ZM14 16H6V14H14V16Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function TaskOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8.82 13.05L7.4 14.46L10.94 18L16.6 12.34L15.19 10.93L10.95 15.17L8.82 13.05Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function UploadFileOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8 15.01L9.41 16.42L11 14.84V19H13V14.84L14.59 16.43L16 15.01L12.01 11L8 15.01Z"
        fill="#424242"
      ></path>
    </svg>
  );
}

export function VerifiedOutlined() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M23 11.99L20.56 9.2L20.9 5.51L17.29 4.69L15.4 1.5L12 2.96L8.6 1.5L6.71 4.69L3.1 5.5L3.44 9.2L1 11.99L3.44 14.78L3.1 18.48L6.71 19.3L8.6 22.5L12 21.03L15.4 22.49L17.29 19.3L20.9 18.48L20.56 14.79L23 11.99ZM19.05 13.47L18.49 14.12L18.57 14.97L18.75 16.92L16.01 17.54L15.57 18.28L14.58 19.96L12.8 19.19L12 18.85L11.21 19.19L9.43 19.96L8.44 18.29L8 17.55L5.26 16.93L5.44 14.97L5.52 14.12L4.96 13.47L3.67 12L4.96 10.52L5.52 9.87L5.43 9.01L5.25 7.07L7.99 6.45L8.43 5.71L9.42 4.03L11.2 4.8L12 5.14L12.79 4.8L14.57 4.03L15.56 5.71L16 6.45L18.74 7.07L18.56 9.02L18.48 9.87L19.04 10.52L20.33 11.99L19.05 13.47Z"
        fill="#9E9E9E"
      />
      <path
        d="M10.09 13.75L7.76998 11.42L6.28998 12.91L10.09 16.72L17.43 9.35999L15.95 7.87L10.09 13.75Z"
        fill="#9E9E9E"
      />
    </svg>
  );
}

export function AccountTreeOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="AccountTreeOutlined">
        <path
          id="Vector"
          d="M22 11V3H15V6H9V3H2V11H9V8H11V18H15V21H22V13H15V16H13V8H15V11H22ZM7 9H4V5H7V9ZM17 15H20V19H17V15ZM17 5H20V9H17V5Z"
          fill="#424242"
        ></path>
      </g>
    </svg>
  );
}

export function BuildOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="BuildOutlined">
        <path
          id="Vector"
          d="M22.6102 18.99L13.5302 9.90997C14.4602 7.56997 13.9802 4.80997 12.0902 2.90997C9.79021 0.609971 6.21021 0.399971 3.66021 2.25997L7.50021 6.10997L6.08021 7.51997L2.25021 3.68997C0.390206 6.22997 0.600206 9.81997 2.90021 12.11C4.76021 13.97 7.47021 14.46 9.79021 13.59L18.9002 22.7C19.2902 23.09 19.9202 23.09 20.3102 22.7L22.6102 20.4C23.0102 20.02 23.0102 19.39 22.6102 18.99ZM19.6102 20.59L10.1502 11.13C9.54021 11.58 8.86021 11.85 8.15021 11.95C6.79021 12.15 5.36021 11.74 4.32021 10.7C3.37021 9.75997 2.93021 8.49997 3.00021 7.25997L6.09021 10.35L10.3302 6.10997L7.24021 3.01997C8.48021 2.94997 9.73021 3.38997 10.6802 4.32997C11.7602 5.40997 12.1702 6.89997 11.9202 8.28997C11.8002 8.99997 11.5002 9.65997 11.0402 10.25L20.4902 19.7L19.6102 20.59Z"
          fill="#9E9E9E"
        ></path>
      </g>
    </svg>
  );
}

export function ContactMailOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H22C23.1 21 23.99 20.1 23.99 19L24 5C24 3.9 23.1 3 22 3ZM22 19H2V5H22V19ZM21 6H14V11H21V6ZM20 8L17.5 9.75L15 8V7L17.5 8.75L20 7V8ZM9 12C10.65 12 12 10.65 12 9C12 7.35 10.65 6 9 6C7.35 6 6 7.35 6 9C6 10.65 7.35 12 9 12ZM9 8C9.55 8 10 8.45 10 9C10 9.55 9.55 10 9 10C8.45 10 8 9.55 8 9C8 8.45 8.45 8 9 8ZM15 16.59C15 14.09 11.03 13.01 9 13.01C6.97 13.01 3 14.09 3 16.59V18H15V16.59ZM5.48 16C6.22 15.5 7.7 15 9 15C10.3 15 11.77 15.49 12.52 16H5.48Z"
        fill="#9E9E9E"
      ></path>
    </svg>
  );
}

export function CreditCardOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="CreditCardOutlined">
        <path
          id="Vector"
          d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
          fill="#9E9E9E"
        ></path>
      </g>
    </svg>
  );
}

export function DrawOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="DrawOutlined">
        <path
          id="Vector"
          d="M18.85 10.39L19.91 9.33C20.69 8.55 20.69 7.28 19.91 6.5L18.5 5.09C17.72 4.31 16.45 4.31 15.67 5.09L14.61 6.15L18.85 10.39ZM14.61 11.81L7.41 19H6V17.59L13.19 10.4L14.61 11.81ZM13.19 7.56L4 16.76V21H8.24L17.43 11.81L13.19 7.56ZM19 17.5C19 19.69 16.46 21 14 21C13.45 21 13 20.55 13 20C13 19.45 13.45 19 14 19C15.54 19 17 18.27 17 17.5C17 17.03 16.52 16.63 15.77 16.3L17.25 14.82C18.32 15.45 19 16.29 19 17.5ZM4.58 13.35C3.61 12.79 3 12.06 3 11C3 9.2 4.89 8.37 6.56 7.64C7.59 7.18 9 6.56 9 6C9 5.59 8.22 5 7 5C5.74 5 5.2 5.61 5.17 5.64C4.82 6.05 4.19 6.1 3.77 5.76C3.36 5.42 3.28 4.81 3.62 4.38C3.73 4.24 4.76 3 7 3C9.24 3 11 4.32 11 6C11 7.87 9.07 8.72 7.36 9.47C6.42 9.88 5 10.5 5 11C5 11.31 5.43 11.6 6.07 11.86L4.58 13.35Z"
          fill="#9E9E9E"
        ></path>
      </g>
    </svg>
  );
}

export function PeopleAltOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="PeopleAltOutlined">
        <g id="Vector">
          <path
            d="M16.67 13.13C18.04 14.06 19 15.32 19 17V20H23V17C23 14.82 19.43 13.53 16.67 13.13Z"
            fill="#9E9E9E"
          ></path>
          <path
            d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
            fill="#9E9E9E"
          ></path>
          <path
            d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
            fill="#9E9E9E"
          ></path>
          <path
            d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
            fill="#9E9E9E"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export function PersonOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 16C14.7 16 17.8 17.29 18 18H6C6.23 17.28 9.31 16 12 16ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
        fill="#9E9E9E"
      ></path>
    </svg>
  );
}

export function StorefrontOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="StorefrontOutlined">
        <path
          id="Vector"
          d="M21.9 8.89L20.85 4.52C20.63 3.62 19.85 3 18.94 3H5.05001C4.15001 3 3.36001 3.63 3.15001 4.52L2.10001 8.89C1.86001 9.91 2.08001 10.95 2.72001 11.77C2.80001 11.88 2.91001 11.96 3.00001 12.06V19C3.00001 20.1 3.90001 21 5.00001 21H19C20.1 21 21 20.1 21 19V12.06C21.09 11.97 21.2 11.88 21.28 11.78C21.92 10.96 22.15 9.91 21.9 8.89ZM18.91 4.99L19.96 9.36C20.06 9.78 19.97 10.2 19.71 10.53C19.57 10.71 19.27 11 18.77 11C18.16 11 17.63 10.51 17.56 9.86L16.98 5L18.91 4.99ZM13 5H14.96L15.5 9.52C15.55 9.91 15.43 10.3 15.17 10.59C14.95 10.85 14.63 11 14.22 11C13.55 11 13 10.41 13 9.69V5ZM8.49001 9.52L9.04001 5H11V9.69C11 10.41 10.45 11 9.71001 11C9.37001 11 9.06001 10.85 8.82001 10.59C8.57001 10.3 8.45001 9.91 8.49001 9.52ZM4.04001 9.36L5.05001 5H7.02001L6.44001 9.86C6.36001 10.51 5.84001 11 5.23001 11C4.74001 11 4.43001 10.71 4.30001 10.53C4.03001 10.21 3.94001 9.78 4.04001 9.36ZM5.00001 19V12.97C5.08001 12.98 5.15001 13 5.23001 13C6.10001 13 6.89001 12.64 7.47001 12.05C8.07001 12.65 8.87001 13 9.78001 13C10.65 13 11.43 12.64 12.01 12.07C12.6 12.64 13.4 13 14.3 13C15.14 13 15.94 12.65 16.54 12.05C17.12 12.64 17.91 13 18.78 13C18.86 13 18.93 12.98 19.01 12.97V19H5.00001Z"
          fill="#9E9E9E"
        ></path>
      </g>
    </svg>
  );
}

export function SupportAgentOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SupportAgentOutlined">
        <g id="Vector">
          <path
            d="M21 12.22C21 6.73 16.74 3 12 3C7.31 3 3 6.65 3 12.28C2.4 12.62 2 13.26 2 14V16C2 17.1 2.9 18 4 18H5V11.9C5 8.03 8.13 4.9 12 4.9C15.87 4.9 19 8.03 19 11.9V19H11V21H19C20.1 21 21 20.1 21 19V17.78C21.59 17.47 22 16.86 22 16.14V13.84C22 13.14 21.59 12.53 21 12.22Z"
            fill="#9E9E9E"
          ></path>
          <path
            d="M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14Z"
            fill="#9E9E9E"
          ></path>
          <path
            d="M15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14Z"
            fill="#9E9E9E"
          ></path>
          <path
            d="M18 11.03C17.52 8.18 15.04 6 12.05 6C9.02 6 5.76 8.51 6.02 12.45C8.49 11.44 10.35 9.24 10.88 6.56C12.19 9.19 14.88 11 18 11.03Z"
            fill="#9E9E9E"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export function FilledActionCalculator() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <path
        fill="#9E9E9E"
        d="M19.071 2H4.93C3.9 2 3 2.875 3 3.875v16.25c0 1 .9 1.875 1.929 1.875H19.07c1.03 0 1.93-.875 1.93-1.875V3.875c0-1-.9-1.875-1.929-1.875zM8.143 19c0 .25-.257.5-.514.5H6.086c-.257 0-.515-.25-.515-.5v-1.5c0-.25.258-.5.515-.5h1.543c.257 0 .514.25.514.5V19zm0-5c0 .25-.257.5-.514.5H6.086c-.257 0-.515-.25-.515-.5v-1.5c0-.25.258-.5.515-.5h1.543c.257 0 .514.25.514.5V14zm5.143 5c0 .25-.257.5-.515.5H11.23c-.258 0-.515-.25-.515-.5v-1.5c0-.25.257-.5.515-.5h1.542c.258 0 .515.25.515.5V19zm0-5c0 .25-.257.5-.515.5H11.23c-.258 0-.515-.25-.515-.5v-1.5c0-.25.257-.5.515-.5h1.542c.258 0 .515.25.515.5V14zm5.143 5c0 .25-.258.5-.515.5h-1.543c-.257 0-.514-.25-.514-.5v-6.5c0-.25.257-.5.514-.5h1.543c.257 0 .515.25.515.5V19zm0-10c0 .25-.258.5-.515.5H6.086c-.257 0-.515-.25-.515-.5V5c0-.25.258-.5.515-.5h11.828c.257 0 .515.25.515.5v4z"
      ></path>
    </svg>
  );
}

export function OrderManagementOrderInfo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" stroke="#9E9E9E" strokeWidth="2" />
      <path stroke="#9E9E9E" d="M12 17v-6" strokeWidth="2" />
      <circle cx="1" cy="1" r="1" fill="#9E9E9E" transform="matrix(1 0 0 -1 11 9)" />
    </svg>
  );
}

export function OrderManagementAllOrders() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#78A75A">
      <path d="M240-80q-50 0-85-35t-35-85v-120h120v-560l60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60v680q0 50-35 85t-85 35H240Zm480-80q17 0 28.5-11.5T760-200v-560H320v440h360v120q0 17 11.5 28.5T720-160ZM360-600v-80h240v80H360Zm0 120v-80h240v80H360Zm320-120q-17 0-28.5-11.5T640-640q0-17 11.5-28.5T680-680q17 0 28.5 11.5T720-640q0 17-11.5 28.5T680-600Zm0 120q-17 0-28.5-11.5T640-520q0-17 11.5-28.5T680-560q17 0 28.5 11.5T720-520q0 17-11.5 28.5T680-480ZM240-160h360v-80H200v40q0 17 11.5 28.5T240-160Zm-40 0v-80 80Z" />
    </svg>
  );
}

export function OrderManagementRemittanceReceivables() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#78A75A">
      <path d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z" />
    </svg>
  );
}

export function OrderManagementFilesInProcess() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#78A75A">
      <path d="M160-120q-33 0-56.5-23.5T80-200v-560q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v560q0 33-23.5 56.5T800-120H160Zm0-80h640v-560H160v560Zm40-80h200v-80H200v80Zm382-80 198-198-57-57-141 142-57-57-56 57 113 113Zm-382-80h200v-80H200v80Zm0-160h200v-80H200v80Zm-40 400v-560 560Z" />
    </svg>
  );
}

export function RemittanceReceivables() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#3a424c">
      <path d="M120-80v-800l60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60v800l-60-60-60 60-60-60-60 60-60-60-60 60-60-60-60 60-60-60-60 60-60-60zm120-200h480v-80H240zm0-160h480v-80H240zm0-160h480v-80H240zm-40 404h560v-568H200zm0-568v568z" />
    </svg>
  );
}

export function LockClockOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 20V10H18V11C18.7 11 19.37 11.1 20 11.29V10C20 8.9 19.1 8 18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H12.26C11.84 21.4 11.51 20.72 11.29 20H6ZM9 6C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H9V6Z"
        fill="#424242"
      />
      <path
        d="M18 13C15.24 13 13 15.24 13 18C13 20.76 15.24 23 18 23C20.76 23 23 20.76 23 18C23 15.24 20.76 13 18 13ZM19.65 20.35L17.5 18.2V15H18.5V17.79L20.35 19.64L19.65 20.35Z"
        fill="#424242"
      />
    </svg>
  );
}

export function LockPersonFilled() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M18 11C18.7 11 19.37 11.1 20 11.29V10C20 8.9 19.1 8 18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H12.26C11.47 20.87 11 19.49 11 18C11 14.13 14.13 11 18 11ZM8.9 6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H8.9V6Z"
        fill="#424242"
      />
      <path
        d="M18 13C15.24 13 13 15.24 13 18C13 20.76 15.24 23 18 23C20.76 23 23 20.76 23 18C23 15.24 20.76 13 18 13ZM18 15C18.83 15 19.5 15.67 19.5 16.5C19.5 17.33 18.83 18 18 18C17.17 18 16.5 17.33 16.5 16.5C16.5 15.67 17.17 15 18 15ZM18 21C16.97 21 16.06 20.48 15.52 19.68C16.25 19.26 17.09 19 18 19C18.91 19 19.75 19.26 20.48 19.68C19.94 20.48 19.03 21 18 21Z"
        fill="#424242"
      />
    </svg>
  );
}

export function ArchiveBox() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 3H3C2.17 3 1.5 3.67 1.5 4.5V7.5C1.5 8.02 1.92 8.44 2.44 8.44H3V21.56C3 22.39 3.67 23.06 4.5 23.06H19.5C20.33 23.06 21 22.39 21 21.56V8.44H21.56C22.08 8.44 22.5 8.02 22.5 7.5V4.5C22.5 3.67 21.83 3 21 3ZM3.94 4.5H20.06V6.94H3.94V4.5ZM19.5 21.56H4.5V8.44H19.5V21.56Z"
        fill="#424242"
      />
      <path
        d="M15 13H9C8.31 13 7.75 12.44 7.75 11.75C7.75 11.06 8.31 10.5 9 10.5H15C15.69 10.5 16.25 11.06 16.25 11.75C16.25 12.44 15.69 13 15 13Z"
        fill="#424242"
      />
    </svg>
  );
}

export function OrderManagementInvoices() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#424242">
      <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM11 19H13V18H14C14.55 18 15 17.55 15 17V14C15 13.45 14.55 13 14 13H11V12H15V10H13V9H11V10H10C9.45 10 9 10.45 9 11V14C9 14.55 9.45 15 10 15H13V16H9V18H11V19Z" />
    </svg>
  );
}

export function CalendarTodayOutlined() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM9 14H7V12H9V14ZM13 14H11V12H13V14ZM17 14H15V12H17V14ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18Z"
        fill="#424242"
      />
    </svg>
  );
}
